var exports = {
  "k": "xdde3148b--3c47ed--container",
  "j": "xdde3148b--3c47ed--padded",
};

module.exports = exports;
